<template>
  <!-- draggable -->
  <el-dialog
      :title="title"
      :width="width"
      center
      v-model="tempModel"
      :fullscreen="fullscreen"
      :close-on-click-modal="closemodal"
      @close="close"
  >
    <template #header>
      <div style="display: flex;justify-content: space-between;align-items: center;height: 20px; padding-top: 15px;">
        <div style="color: white; margin-left: 15px;">{{ title }}</div>
        <div style="margin-right:30px;" @click="fullscreen = !fullscreen">
          <el-button link style="border: none;color: #909399; margin-right: 10px;">
            <el-icon v-if="!showfullscreen" color="white">
              <full-screen/>
            </el-icon>
          </el-button>
          <div class="el-dialog__headerbtn"></div>
        </div>
      </div>
    </template>
    <div style="overflow:auto;">
      <slot></slot>
    </div>
    <template #footer>
      <slot name="footer"></slot>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: "yzDialog",
  components: {},
  mounted() {
    if (this.defaultFull != null) this.fullscreen = this.defaultFull
  },
  data() {
    return {
      fullscreen: false,
    }
  },
  computed:{
    tempModel:{
      get(){
        return this.open
      },
      set(value){
        this.$emit('update:open',value)
      },
      close(){
        this.$emit('close')
      }
    }
  },
  props:['title','width','defaultFull','open','closemodal','showfullscreen'], // {title:String, width:Number, defaultFull:Boolean, open: Boolean},
  emits: ['update:open'],
}
</script>

<style lang="less">
//.el-dialog--center{}
//.el-dialog__header {
//  background-color: #3C8DBC;
//  margin-right: 0px;
//}
.el-dialog {
  .el-dialog__header {
    padding: 8px 10px 8px 10px;
    background-color:  #326EFF;
    margin-right: 0px;

    .el-dialog__headerbtn {
      width: 28px;
      height: 28px;
      margin-right:8px;
      margin-top: 9px;
      .el-dialog__close {
        color: white;
      }
    }
  }

  .el-dialog__body {

    background: white;
  }

  .el-dialog__footer {
    background-color: white;
    padding: 0;
  }
}


</style>
